import { AbilityBuilder, Ability } from '@casl/ability'

export default new Ability()

export function defineAbilityFor(user) {
  const { can, rules } = new AbilityBuilder(Ability)

  user.rules.map(rule => rule.actions.map(action => can(action, rule.subject)))

  return rules
}